module.exports = __webpack_public_path__ + "static/media/passphoto2.06d23c8b.jpg";